export const BASE = "/";
export const LOGINPATH = "/login";
export const SIGNUPPATH = "/createpassword";
export const SIGNOUTPATH = "/signout";
export const EVENTTAGPATH = "eventTag";
export const ROLESPATH = "roles";
export const USERSPATH = "users";
export const CREATEUSER = "/users/createuser";
export const EDITUSER = "/users/edituser/:userId";
export const GROUPPATH = "/groups";
export const EVENTPATH = "/events";
export const RANKPATH = "/ranks";
export const EMAILCONFIRMATION = "/auth/emailconfirmed";
export const CREATEPASSWORD = "/auth/createpassword";
export const ACCESSDENIED = "/accessDenied";
export const NOTFOUND = "*";
export const FORGOTPASSWORD = "/forgotpassword";
export const RESETPASSWORD = "/resetpassword";
export const MYPROFILE = "/myprofile";
export const USERANALYTICSPATH = "/users/useranalytics/:userId";
export const MANDATORYMESSAGEDASHBOARD = "/mandatorymessagedashboard";
export const EVENTMESSAGEDASHBOARD = "/eventmessagedashboard";
export const AISUMMARYREPORT = "/aisummaryreport";
export const ALLMESSAGESPATH = "/allmessages";
export const ASSEMBLYCONSTITUENCYPATH = "/assemblyConstituency";
export const RIOPATH = "/rio";
